import {
  mutationOptions,
  queryOptions,
  skipToken,
  type UseMutationOptions,
} from "@tanstack/react-query";
import { createInvoker, type Operations, ToolClientError } from "@tycho/client";
import { clientEnv } from "./env";

const client = createInvoker({ baseUrl: clientEnv.VITE_API_URL });
type Route = keyof Operations;
type Mutation<R extends Route> = Operations[R]["input"] & { idempotencyKey: string };
export const tools = {
  queryKey: (route: Route) => ["tool", route] as const,
  queryOptions<R extends Route>(route: R, input: Operations[R]["input"] | typeof skipToken) {
    return queryOptions({
      queryKey: ["tool", route, input] as const,
      queryFn:
        input === skipToken ? skipToken : ({ signal }) => client.invoke(route, input, { signal }),
    });
  },
  mutationOptions<R extends Route>(
    route: R,
    options: Omit<
      UseMutationOptions<Operations[R]["output"], Error, Mutation<R>>,
      "mutationKey" | "mutationFn"
    > = {},
  ) {
    return mutationOptions({
      mutationKey: ["tool", route],
      mutationFn: ({ idempotencyKey, ...input }: Mutation<R>) =>
        client.invoke(route, input as Operations[R]["input"], { idempotencyKey }),
      retry: (count, error) =>
        error instanceof ToolClientError && error.detail.retryable && count < 10,
      retryDelay: (_, error) =>
        error instanceof ToolClientError ? (error.detail.retryAfterMs ?? 1000) : 1000,
      ...options,
    });
  },
};
export type SubmittedPlan =
  Operations["GET /api/conversations/{id}"]["output"]["submittedPlans"][number];
